/* eslint-disable function-paren-newline */
import {
    DEFAULT_CURRENCY,
    MANDATE_FREQUENCY_ENUM,
} from '../../../utils/constants/commonValues';

function MandateList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

MandateList.prototype = Object.assign(MandateList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.merchantMandateResponseList &&
            tableData.merchantMandateResponseList.map(row =>
                this.createRow(row)
            )
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            subscriptionId,
            customerId,
            startDate,
            lastPaidDate,
            dueDate,
            state,
            frequency,
            lastPaidAmount,
            payType,
            allowedActions,
            remarks,
            createdAt,
            customerDetails,
            billingDetails,
            entityCode,
            mandateProductRefId,
            paymentInstrument,
        } = row;
        return {
            payType: payType || '-',
            lastPaidAmount: lastPaidAmount || '-',
            frequency: frequency || '-',
            entityCode: entityCode || '-',
            subscriptionID: subscriptionId || '-',
            customerID: customerId || '-',
            startDate: startDate || '-',
            lastPaidAt: lastPaidDate || '-',
            nextDueOn: dueDate || '-',
            createdAt: createdAt || '-',
            lastPaidDate:
                this.getDateStringFromDateAndTime(lastPaidDate) || '-',
            nextDueOnDate: this.getDateStringFromDateAndTime(dueDate) || '-',
            createdAtDate: this.getDateStringFromDateAndTime(createdAt) || '-',
            paymentInfo: this.getPaymentInfoString(
                billingDetails,
                paymentInstrument
            ),
            status: state || '-',
            allowedActions: allowedActions || [],
            remarks: remarks || '',
            emailId: customerDetails.userEmail || '-',
            phoneNo: customerDetails.userMobileNo || '-',
            billingDetails: this.setBillingDetails(billingDetails) || {},
            mandateProductRefId: mandateProductRefId || '-',
        };
    },
    setBillingDetails(billingDetails) {
        const { payType, frequency, billingAmount } = billingDetails;
        const formattedBillingDetails = {
            payType,
            frequency: this.getBillingFrequency(frequency),
            billingAmount: this.getBillingAmount(billingAmount),
        };
        return formattedBillingDetails;
    },
    getBillingFrequency(type) {
        if (!type) {
            return '-';
        }
        return MANDATE_FREQUENCY_ENUM[type];
    },
    getBillingAmount(amount) {
        return amount ? `${DEFAULT_CURRENCY} ${amount}` : '-';
    },
    getDateStringFromDateAndTime(date) {
        if (!date) {
            return '-';
        }
        try {
            return date.split(' ')[0];
        } catch (error) {
            return date;
        }
    },
    getPaymentInfoString(billingDetails, paymentInstrument) {
        return `${billingDetails.payType || '-'} -  ${paymentInstrument ||
            '-'}`;
    },
});

export default MandateList;
